import request from '@/utils/requestV2'
const qs = require('qs')

// 素材历史作业时间点
export function getImagePublishRecord (data) {
  return request.post('/ooh-msp/v1/search/getImagePublishRecord', qs.stringify(data))
}

// 素材在刊点位
export function getImageResourcePage (data) {
  return request.post('/ooh-msp/v1/search/getImageResourcePage', qs.stringify(data))
}

// AI素材收索结果
export function getSearchResultList (data) {
  return request.post('/ooh-msp/v1/search/getSearchResultList', qs.stringify(data))
}

// 素材指定作业日期在刊站点分布统计
export function getStationTaskCount (data) {
  return request.post('/ooh-msp/v1/search/getStationTaskCount', qs.stringify(data))
}

// 获取站点任务集合
export function getStaionTaskList (data) {
  return request.post('/ooh-msp/v1/search/getStaionTaskList', qs.stringify(data))
}
